export const ColumnHeader = [
  {
    id: 1,
    tittle: "Pays de production",
    property: "pays.libelle",
    toSort: true,
  },
  {
    id: 2,
    tittle: "Bu",
    property: "bus.libelle",
    toSort: true,
  },
  {
    id: 3,
    tittle: "Client",
    property: "clients.libelle",
    toSort: true,
  },
  {
    id: 4,
    tittle: "Operation",
    property: "operations.libelle",
    toSort: true,
  },
  {
    id: 5,
    tittle: " Code article",
    property: "code_articles.libelleCodeArticle",
    toSort: false,
  },
  {
    id: 6,
    tittle: " Type",
    property: "type_libelle",
    toSort: false,
  },
  {
    id: 7,
    tittle: "Désignation article",
    property: "articles.libelle",
    toSort: true,
  },
  {
    id: 8,
    tittle: "Mois",
    property: "budgets.mois",
    toSort: true,
  },
  {
    id: 9,
    tittle: "Annee",
    property: "budgets.annee",
    toSort: true,
  },
  {
    id: 10,
    tittle: "CA_Budget",
    property: "budgets.ca_budget",
    toSort: false,
  },
  {
    id: 11,
    tittle: "Taux Marge budget",
    property: "budgets.tx_marge_budget",
    toSort: false,
    width: 75
  },
  {
    id: 12,
    tittle: "Marge Valeur Budget",
    property: "budgets.marge_valeur_budget",
    toSort: false,
    width: 85
  },
  {
    id: 13,
    tittle: "Heure Budget",
    property: "budgets.qte_acte_budget",
    toSort: false,
    width: 75
  },
  {
    id: 14,
    tittle: "Acte Budget",
    property: "budgets.qte_heure_budget",
    toSort: false,
    width: 75
  },
 /* {
    id: 14,
    tittle: "Heure coût budget",
    property: "budgets.heure_cout_budget",
    toSort: false,
    width: 100
  },*/
  {
    id: 16,
    tittle: "DMT",
    property: "budgets.dmt",
    toSort: false,
    width: 80
  },
  {
    id: 17,
    tittle: "Taux occupation (%)",
    property: "budgets.taux_occupation",
    toSort: false,
    width: 80
  },
  {
    id: 18,
    tittle: "Taux congés (%)",
    property: "budgets.taux_conges",
    toSort: false,
    width: 80
  },
  {
    id: 19,
    tittle: "Taux absentéisme (%)",
    property: "budgets.taux_absenteisme",
    toSort: false,
    width: 80
  },
  {
    id: 15,
    tittle: "Actions",
    toSort: false,
  },
];

export interface IYearsVerouillageClotureLocked {
  YearsVerouillageBudget: number[]
  YearsClotureBudget: number[]
}
